'use client';

import { useState } from 'react';
import Image from 'next/image';
import { getAbbreviation } from '@/utils/getAbbreviation';

interface AgentAvatarProps {
  label: string;
  image?: string | null;
  size: number;
  className?: string;
}

export const AgentAvatar = ({ label, image, size, className = '' }: AgentAvatarProps) => {
  const [imgError, setImgError] = useState(false);
  const initials = getAbbreviation(label).slice(0, 2).toUpperCase() || '?';

  if (image) {
    return (
      <div className={`rounded-full overflow-hidden shrink-0 ${className}`} style={{ width: size, height: size }}>
        <Image
          src={imgError ? '/images/smartflyer-profile-fallback.jpeg' : image}
          alt={label}
          width={size}
          height={size}
          className="object-cover w-full h-full"
          onError={() => setImgError(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={`rounded-full bg-blue-100 flex items-center justify-center shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <span className="text-blue-900 font-medium font-inter" style={{ fontSize: size <= 24 ? '10px' : '11px' }}>
        {initials}
      </span>
    </div>
  );
};
